// export const API_URL = "https://staging-api-cms.mirchi.ae/api/v1/"; // commented
export const API_URL = "https://api-cms.mirchi.ae/api/v1/";
// export const API_URL = "https://api-radiomirchi.grappus.com/api/v1/";
// export const API_URL = "http://localhost:3012/api/v1/";

// export const API_URL = process.env.NODE_ENV === "development" ?
//   "http://api-radiomirchi.grappus.com/api/v1/":
//   "https://api-cms.radiomirchiusa.com/api/v1/";
export const WP_URL = "https://mirchiplay.com/wp-json/wp/v2/";